"use strict";
export const copyToClipboard = async (value, onError) => {
  if (navigator?.clipboard) {
    try {
      await navigator.clipboard.writeText(value);
    } catch {
      fallback(value, onError);
    }
  } else {
    fallback(value, onError);
  }
};
const fallback = (value, onError) => {
  try {
    const copyElement = document.createElement("textarea");
    copyElement.value = value;
    document.body.appendChild(copyElement);
    copyElement.select();
    document.execCommand("copy");
    copyElement.remove();
  } catch (error) {
    if (onError) onError();
  }
};
